import { ReactElement } from 'react';
import { Button, Alert } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useRoutes } from '@localstack/services';

import { AdminPermission } from '@localstack/types';

import { AppRoute } from '~/config';
import { AdminLayout } from '~/layouts';
import { useAuthProvider } from '~/hooks/useAuthProvider';

export const Accounts = (): ReactElement => {
  const { goto } = useRoutes();
  const { can } = useAuthProvider();

  return (
    <AdminLayout
      title="Manage User Accounts"
      trailingActions={
        <Button
          variant="text"
          startIcon={<AddIcon />}
          onClick={() => goto(AppRoute.ADMIN_CREATE_ACCOUNT)}
          disabled={!can(AdminPermission.USERS_WRITE)}
        >
          Create User
        </Button>
      }
    >
      <Alert severity="info">
        This page no longer shows a list of users. You can only create new users or search for existing ones.
      </Alert>
    </AdminLayout>
  );
};
